import { useGetFeatureFlags } from 'api/services/featureFlagService';


//Hook for get 
export const useFeatureFlag = (flagkey: string) => {
  const { data: featureFlagsData } = useGetFeatureFlags();
  const isEnabled = featureFlagsData?.data?.flags?.[flagkey]?.enabled ?? false;

  return isEnabled;
};
